import { useLocation } from "react-router-dom";
import type { MenuItem } from "./types";

/** Normalize path for comparisons (trim trailing slash except root) */
function normalize(path: string): string {
  if (!path) return "/";
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path;
}

/** Check if pathname is active for a given target route */
function matchPath(pathname: string, to: string): boolean {
  const a = normalize(pathname);
  const b = normalize(to);
  if (a === b) return true;

  // Match full segment boundary: "/a/b" should not activate "/a/board"
  return a.startsWith(b + "/");
}

export const useActiveRoute = () => {
  const { pathname } = useLocation();
  const isActiveLink = (to: string) => matchPath(pathname, to);

  const isActiveGroup = (children: MenuItem[]) =>
    children.some((c) => c.type === "link" && isActiveLink(c.to));

  return { pathname, isActiveLink, isActiveGroup };
};
